import type { Factory } from 'walden-fast/types/mocks';
import type { OrganisationUser } from 'walden-fast/types/user';
import { selectRandom } from './lists';

const MOCK_ORGANISATION_USER: OrganisationUser = {
  id: '1',
  firstName: 'John',
  lastName: 'Doe',
  displayName: 'John Doe',
  email: 'johndoe@walden-group.com',
  client: 'Walden',
};

export const organisationUserFactory: Factory<OrganisationUser> = (
  overrides,
) => ({
  ...MOCK_ORGANISATION_USER,
  id: `${Math.floor(Math.random() * 1000)}`,
  client: `Walden ${selectRandom(['BE', 'NL', 'FR'])}`,
  ...overrides,
});
